import customConfigResource from '@/api/resources/ui/CustomConfigResource'
import { merge, keyBy } from 'lodash'
import { AssaygroupTypeEnum } from '@/api/services/common/assaygroup/common-assaygroup.dto'
import sectionServices from '@/api/resources/common/sectionServices'

export default {
    data() {
        return {
            visible: false,
            sidebarCustomConfig: null,
            sections: []
        }
    },
    methods: {
        async _loadSections() {
            this.sections = await sectionServices.getSections(this.$store.getters.labId)
            this.sections = this.sections.filter(section => section.active)
            this.sections.forEach(section => (section.isCytology = section.assaygroups.map(assaygroup => assaygroup.type).includes(AssaygroupTypeEnum.CYTOLOGY)))
        },
        async loadSidebarCustomConfig() {
            await this._loadSections()

            this.sidebarCustomConfig = await customConfigResource.get('uicomponent.laboratory.sidepanel')
            if (this.sidebarCustomConfig) {
                const savedSections = Object.values(this.sidebarCustomConfig.config)
                const savedSectionIds = savedSections.map(section => section.id)
                const sections = this.sections.filter(section => savedSectionIds.includes(section.id))
                const sectionsIds = sections.map(section => section.id)
                const userSections = savedSections.filter(userSectionInfo => sectionsIds.includes(userSectionInfo.id))
                this.sections =
                    Object.values(
                        merge(
                            keyBy(this.sections, 'id'),
                            keyBy(userSections, 'id')))
                this.visible = true
            } else {
                this.$forceUpdate()
            }
        },
        async saveSidebarCustomConfig() {
            await customConfigResource.save('uicomponent.laboratory.sidepanel', {
                ...this.sections.map(section => ({ id: section.id, checked: section.checked }))
            })
        }
    }
}
